import { Todo } from '../../../models'
import LOG from '../../../logging/Logger'
import _ from 'lodash'

const resequenceAllowGaps = (todos, offset, up, clientId) => {
  let indexCounter = offset
  const changed = _.map(todos, todo => {
    let updatedTodo = null
    if (todo.position === null) {
      updatedTodo = Todo.copyOf(todo, updated => {
        updated.clientId = clientId
        updated.position = indexCounter
      })
      indexCounter = up ? indexCounter + 1 : indexCounter - 1
    } else if (up) {
      if (todo.position < indexCounter) {
        updatedTodo = Todo.copyOf(todo, updated => {
          updated.clientId = clientId
          updated.position = indexCounter
        })
        indexCounter++
      } else {
        indexCounter = todo.position + 1
      }
    } else if (todo.position > indexCounter) {
      updatedTodo = Todo.copyOf(todo, updated => {
        updated.clientId = clientId
        updated.position = indexCounter
      })
      indexCounter--
    } else {
      indexCounter = todo.position - 1
    }

    return updatedTodo
  }).filter(todo => {
    return todo
  })
  return changed
}

const resequenceNoGaps = (todos, offset, up, clientId) => {
  let indexCounter = offset
  const changed = _.map(todos, (todo, index) => {
    let updatedTodo = null
    if (todo.position !== indexCounter) {
      updatedTodo = Todo.copyOf(todo, updated => {
        updated.clientId = clientId
        updated.position = indexCounter
      })
    }
    indexCounter = up ? indexCounter + 1 : indexCounter - 1
    return updatedTodo
  }).filter(todo => {
    return todo
  })
  return changed
}

const shortest = (...array) => {
  let best = null
  array.forEach(item => {
    if (item && (!best || item.length < best.length)) {
      best = item
    }
  })
  return best ? best : []
}

export default class TodoPositions {
  static updateTodoPositionsReturnChanged(
    clientId,
    todos,
    minimiseChanges = false
  ) {
    LOG.debug('Setting TODO position based on array order', todos)

    if (!todos || todos.length === 0) {
      return []
    }

    let threshold = 0
    if (!minimiseChanges) {
      if (todos.length > 100) {
        threshold = 5
      } else if (todos.length > 500) {
        threshold = 10
      }
    }

    // 1. Based on position of first item in list
    let indexOffset = todos[0].position
    const changed1 = resequenceAllowGaps(todos, indexOffset, true, clientId)

    let changed2, changed3, changed4, changed5, changed6
    if (changed1.length > threshold) {
      // 2. Based on position of last item in list
      const reverseTodos = todos.slice(0).reverse()
      indexOffset = reverseTodos[0].position
      changed2 = resequenceAllowGaps(reverseTodos, indexOffset, false, clientId)

      if (changed2.length > threshold) {
        // 3. Based on size of array
        indexOffset = todos.length - 1
        changed3 = resequenceAllowGaps(reverseTodos, indexOffset, false, clientId)

        if (changed3.length > threshold) {
          // 4. Based on starting at 0
          indexOffset = 0
          changed4 = resequenceAllowGaps(todos, indexOffset, true, clientId)

          if (changed4.length > threshold) {
            // 5. Straight count up
            indexOffset = todos[0].position
            changed5 = resequenceNoGaps(todos, indexOffset, true, clientId)

            if (changed5.length > threshold) {
              // 6. Straight count down
              indexOffset = reverseTodos[0].position
              changed6 = resequenceNoGaps(todos, indexOffset, false, clientId)
            }
          }
        }
      }
    }

    return shortest(changed1, changed2, changed3, changed4, changed5, changed6)
  }
}
